import React from 'react';
import SideDrawer from '../_custom/SideDrawer/SideDrawer';
import Button from '../_custom/Button/Button';
import LoadingSpinner from '../_custom/LoadingSpinner/LoadingSpinner';
import DocumentViewer from './DocumentViewer';
import { downloadIconDataRoomHovered } from '../../assets/hostedassets';
import styles from './FileViewerDrawer.module.scss';

interface FileViewerDrawerProps {
    heading: string;
    fileUrl: string;
    mimeType?: string;
    downloading?: boolean;
    downloadLabel?: string;
    onDownload: () => void;
    onClose: () => void;
}

/**
 * Shared preview drawer used by the dataroom (File) and the GST Analysis report.
 * Presentational only — the caller resolves the presigned `fileUrl`/`mimeType`
 * (via useFetchDataRoomFiles) and owns the open/close gating.
 */
const FileViewerDrawer: React.FC<FileViewerDrawerProps> = ({
    heading,
    fileUrl,
    mimeType,
    downloading = false,
    downloadLabel = 'Download',
    onDownload,
    onClose,
}) => {
    return (
        <SideDrawer
            heading={heading}
            showHeading={true}
            width="75%"
            allowClose
            onClose={onClose}
            headerActions={
                <Button
                    type="button"
                    aria-label={`Download ${heading}`}
                    text={downloadLabel}
                    className={styles.downloadBtn}
                    icon={
                        downloading ? <LoadingSpinner color="#6021B3" style={{ margin: '0', padding: '0' }} /> : downloadIconDataRoomHovered
                    }
                    iconStyles={{ height: '0.9375rem' }}
                    onClick={(e) => {
                        e.stopPropagation();
                        onDownload();
                    }}
                />
            }
        >
            <DocumentViewer fileUrl={fileUrl} mimeType={mimeType} />
        </SideDrawer>
    );
};

export default FileViewerDrawer;
